import store from '@/store';
import consts from '@/static/js/consts';

export default {
  /**
   * Performa user authentication
   *
   * @param {String} username
   * @param {String} password
   * @returns {Promise} user data
   */
  login(username, password, passwordConfirmation) {
    return store.dispatch(consts.USER_ACTIONS.LOGIN, {
      username_type: 'email',
      email: username,
      password,
      password_confirmation: passwordConfirmation,
    })
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  },
  /**
   * Performa user registration
   *
   * @param {String} name
   * @param {String} cpf
   * @param {String} cellphone
   * @param {String} email
   * @param {String} password
   * @param {String} passwordConfirmation
   * @returns {Promise} user data
   */
  register(registerForm) {
    return store.dispatch(consts.USER_ACTIONS.REGISTER, registerForm)
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  },

  /**
   * Request the password reset
   *
   * @param {String} username
   */
  resetPassword(code, password) {
    return store.dispatch(consts.USER_ACTIONS.RESET_PASSWORD, {
      recovery_token: code,
      password,
    })
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  },

  verifyEmail(useremail) {
    return store.dispatch(consts.USER_ACTIONS.VALIDATE_EMAIL, {
      username_type: 'email',
      email: useremail,
    })
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  },

  /**
   * Request the password reset
   *
   * @param {String} resetKey
   * @param {String} String
   */
  setNewPassword(password, newPassword) {
    return store.dispatch(consts.USER_ACTIONS.UPDATE_PASSWORD, {
      password,
      new_password: newPassword,
    })
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  },

  LogOut() {
    return store.dispatch(consts.USER_ACTIONS.LOGOUT)
      .then((result) => result)
      .catch((err) => {
        throw err;
      });
  },
};
